import { render } from "./Mb044.vue?vue&type=template&id=5586651f&scoped=true"
import script from "./Mb044.vue?vue&type=script&lang=js"
export * from "./Mb044.vue?vue&type=script&lang=js"

import "./Mb044.vue?vue&type=style&index=0&id=5586651f&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5586651f"]])

export default __exports__